// import { useAppSelector } from "app/hooks";
import { LISCase, LISCaseListPatient } from "pwapi";

const PatientFullName = ({
  patient,
}: {
  patient?: LISCase["patient"] | LISCaseListPatient;
}) => {
  // const patientFirstName = useAppSelector(
  //   (state) => state.patients[id || 0]?.first_name
  // );
  // const patientLastName = useAppSelector(
  //   (state) => state.patients[id || 0]?.last_name
  // );

  if (!patient) return null;

  return (
    <>{[patient.last_name, patient.first_name].filter((s) => !!s).join(", ")}</>
  );
};

export default PatientFullName;
